import React from 'react'
import Slider from './Slider'

const Header = () => {
  return (
    <header className='Header' id="home">
      <Slider/>
    </header>
  )
}

export default Header